import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { useNavigate, useOutletContext } from 'react-router-dom';

import { 
  Button, 
  Box, 
  Typography, 
  Container,
  CircularProgress,
  TextField
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';


import { Scanner } from '../utils';
import { CONST, TokenValidator } from '../../utils';
import { Sessions } from '../../controllers';


export default function Login() {
  const {Login:Context} = useOutletContext();

  document.title = 'Login';
  const nav = useNavigate();

  const [tag, setTag] = React.useState('');
  const [fetching, setFetch] = React.useState(false);
  const [loging, setLog] = React.useState(false);

  React.useEffect(() => {
    handleLoading();
  },[]);

  const handleLoading = async() => {
    setFetch(true);

    const result = await TokenValidator.GetStaffUser();

    if(result == null){
      setFetch(false);
      return;
    }

    setFetch(false);

    if(!await TokenValidator.ValidTokenDate(result)){
      return;
    }

    confirmLogin();
  }


  const handleLogin = async(e) => {
    e.preventDefault();
    const result = await Sessions.Direct(tag);
    
    setFetch(true);
    
    if(!result.success){
      alert(result.message);
      setFetch(false);
      return;
    }

    localStorage.setItem(CONST.STORAGE_KEYS.STAFF_LOGIN, JSON.stringify(result.token));
    setFetch(false);
    confirmLogin();
  }

  const confirmLogin = async() => {
    Context.Confirmation(true);
    setLog(true);
    nav('main', {replace: true});
  }

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography component="h1" variant="h5">
          Tracking Station - Sign in
        </Typography>
  
        <Box 
          sx={{ mt: 1 }} 
          component='form'
          onSubmit={handleLogin}
        >
           <TextField
              margin="normal"
              required
              fullWidth
              label="Credential"
              id="tag"
              name="tag"
              type="password"
              autoFocus
              value={tag}
              onChange={e => setTag(e.target.value)}
              disabled={fetching}
          />
          <Button
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            type='submit'
            disabled={fetching}
          >
            Submit
          </Button>
        </Box>

        {fetching && (
          <Box sx={{ 
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}>
            <Typography component="h1"  variant="h5">
              Getting User
            </Typography>
            <br/>
            <CircularProgress 
              color='primary'
            />
          </Box>
        )}

        {loging  && (
          <Box
            sx={{ 
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <CheckIcon color='primary'/>
            <p>
              Login successfull, redirecting...
            </p>
          </Box>
        )}

      </Box>
      <hr/>
    </Container>
  );
}